import React, { useEffect, useState } from "react";
import * as css from "./style.m.css";
import warningImg from './assets/warning.svg'
import { routerConfig } from "../../config/router-list";
import { queryString, getAppPathFromType } from '@src/utils/common'
import history from "@src/utils/history";
import { getHasNewVersion } from '../../thunk'
import * as actions from "../../action";
import { useDispatch } from "redux-react-hook";
import useMappedState from "@src/utils/useMappedState";

const versionTip = props => {
  const { style: mStyle, content } = props;
  const id = queryString('id');
  const type = queryString('type');
  const dispatch = useDispatch()
  const { hasNewVersion } = useMappedState("appdetailV2");

  const clickCreateVersion = () => {
    history.push(`/${type}/appdetailV2${routerConfig.editionManage}?id=${id}&type=${type}`);
  }

  useEffect(() => {
    reqNewVersion();
  }, []);

  const reqNewVersion = async () => {
    const res = await getHasNewVersion(id, type);
    if (res?.status === 1) {
      const { appDifferentInfo, h5IsUpdate, weAppIsUpdate, robotIsUpdate } = res?.data || {};
      if (appDifferentInfo || h5IsUpdate || weAppIsUpdate||robotIsUpdate) {
        dispatch(actions.setHasNewVersion(true))
      } else {
        dispatch(actions.setHasNewVersion(false))
      }
    } else {
      dispatch(actions.setHasNewVersion(false))
    }
  }

  return (
    <>
      {hasNewVersion ? <div className={css['version-tip']} style={{ ...mStyle }}>
        <img className={css['warning-img']} src={warningImg}></img>
        {content ? content : (
          <>
            <span >当前修改需在版本发布后生效，</span>
            <span className={css['create-version']} onClick={clickCreateVersion}>创建版本</span>
          </>
        )}
      </div> : ''}
    </>
  );
};

export default versionTip;
